export const getRecordKeys: <K extends string>(r: Record<K, unknown>) => K[] =
  Object.keys;
export const getRecordValues: <V>(
  r: Record<string | number | symbol, V>,
) => V[] = Object.values;
export const getRecordEntries: <K extends string, V>(
  r: Record<K, V>,
) => [K, V][] = Object.entries;
